import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../AuthContext';
import api from '../axiosInstance';
import { buildHostedLogoutUrl } from '../config';

const noop = () => {};

export default function useSignOut() {
  const navigate = useNavigate();
  const context = useContext(AuthContext) || {};
  const {
    setIsAuthenticated = noop,
    setUser = noop,
  } = context;

  return useCallback(async ({ redirectTo = '/', replace = false, hostedLogout = true } = {}) => {
    try {
      await api.post('/api/auth/logout');
    } catch (_) {}

    localStorage.removeItem('userLoggedIn');
    setIsAuthenticated(false);
    setUser(null);

    if (hostedLogout) {
      try {
        const hostedLogoutUrl = buildHostedLogoutUrl();
        if (hostedLogoutUrl) {
          window.location.href = hostedLogoutUrl;
          return;
        }
      } catch (_) {}
    }

    if (redirectTo === null) {
      return;
    }

    if (navigate) {
      navigate(redirectTo, { replace });
    } else {
      window.location.href = redirectTo;
    }
  }, [navigate, setIsAuthenticated, setUser]);
}
